import { PHeading, PText } from "@porsche-design-system/components-react"
import type { LocalizedLink } from "@slfinrtl/ui-bff-routes"
import { useMemo } from "react"
import { defineMessages, FormattedMessage } from "react-intl"
import { FormLayout } from "src/components"
import type { RadioOption } from "src/components"
import { RadioGroup } from "src/components/form/radio/radioGroup/RadioGroup"

const messages = defineMessages({
	languageHeadline: {
		defaultMessage: "Choose Language",
		id: "openListing.modal.language.headline",
	},
	languageSubheadline: {
		defaultMessage: "Choose the language in which you want to open the listing.",
		id: "openListing.modal.language.subheadline",
	},
})

export interface OpenListingProps {
	links: LocalizedLink[]
	onSelectedUrlChanged: (url: string) => void
	selectedUrl: string | undefined
}

export const OpenListing = ({ links, onSelectedUrlChanged, selectedUrl }: OpenListingProps) => {
	const options = useMemo((): RadioOption[] => links.map((link) => ({ label: link.name, value: link.url })), [links])

	return (
		<FormLayout>
			<div>
				<PHeading size="md">
					<FormattedMessage {...messages.languageHeadline} />
				</PHeading>
				<PText>
					<FormattedMessage {...messages.languageSubheadline} />
				</PText>
			</div>
			<RadioGroup
				name="language"
				value={selectedUrl}
				onChange={onSelectedUrlChanged}
				required
				options={options}
			/>
		</FormLayout>
	)
}
